/* eslint-disable react/prop-types */
/* eslint-disable no-redeclare */
import React, { useState } from "react";
import Logo from "../../Images/Logo.svg";
import { TiArrowSortedDown } from "react-icons/ti";
import { LuMenuSquare } from "react-icons/lu";
import { ImCancelCircle } from "react-icons/im";
import { Link } from "react-router-dom";

const Header = () => {
  const [toggle, setToggle] = useState();

  const showToggle = () => {
    setToggle(!toggle);
  };
  return (
    <>
      <div className="sticky top-0 bg-white z-10 border-b p-0 m-0 box-border">
        <div className="w-[95%] mx-auto font-Urbanist font-semibold p-4 flex justify-start  items-center">
          <Link to="/">
            <div className="w-[200px] xl:w-[300px] cursor-pointer">
              <img src={Logo} alt="" className="w-[150px]" />
            </div>
          </Link>
          <div className="">
            <ul className="hidden lg:flex justify-center flex-wrap lg:flex-nowrap space-x-6 xl:space-x-8 text-xl items-center gap-2">
              <Link to="/">
                <li className="nav-link">Home</li>
              </Link>
              <Link to="/about">
                {" "}
                <li className="nav-link">About</li>
              </Link>
              <div className="nav-link nav flex justify-center items-center">
                <button>Services</button>
                <TiArrowSortedDown />
                <div className="nav-content">
                  <Link to="/drain-unblocking">
                    <li>Drain Unblocking</li>
                  </Link>
                  <Link to="/waste-management">
                    <li>Waste Management</li>
                  </Link>
                  <Link to="/kitchen">
                    <li>Kitchens Installations and Repairs</li>
                  </Link>
                  <Link to={"/plumbing"}>
                    <li>Plumbing</li>
                  </Link>
                  <Link to="/haulage">
                    {" "}
                    <li>Haulage and Removals</li>
                  </Link>
                 
                  <Link to="/admin-dashboard">
                    {" "}
                    <li>Admin-Dashboard</li>
                  </Link>
                </div>
              </div>
              <Link to="/project">
                <li className="nav-link">Projects</li>
              </Link>
              <Link to="/login">
                <li className="nav-link">Login</li>
              </Link>
              <Link to="/admin">
                <li className="nav-link">Admin-Login</li>
              </Link>
             
            </ul>
          </div>
        </div>
        <div
          onClick={showToggle}
          className="absolute cursor-pointer lg:hidden top-12 right-6"
        >
          <LuMenuSquare className="text-4xl text-gray-600" />
        </div>
      </div>
      {toggle ? (
        <div className="lg:hidden fixed w-screen h-screen bg-white top-0 right-0  duration-[950ms] z-50">
          <Link to="/home">
            <div className="w-[200px] mt-4 mx-6">
              <img src={Logo} alt="" className="w-[180px]" />
            </div>
          </Link>
          <div className="absolute top-10 right-6">
            <ImCancelCircle
              onClick={showToggle}
              className="text-4xl  cursor-pointer text-red-600"
            />
          </div>
          <div className="w-[120px] mx-6">
            <ul className=" space-y-6  text-xl pt-10 items-center  gap-4 xl">
              <Link to="/">
                <li onClick={showToggle} className="nav-link pt-6">
                  Home
                </li>
              </Link>
              <Link to="/about">
                <li onClick={showToggle} className="nav-link">
                  About
                </li>
              </Link>
              <div className="nav-link nav">
                <button>Services</button>
                <TiArrowSortedDown className="" />
                <div className="nav-contents">
                  <Link onClick={showToggle} to="/drain-unblocking">
                    <li>Drain Unblocking</li>
                  </Link>
                  <Link onClick={showToggle} to="/waste-management">
                    <li>Waste Management</li>
                  </Link>
                  <Link onClick={showToggle} to="/kitchen">
                    <li>Kitchens Installations and Repairs</li>
                  </Link>
                  <Link onClick={showToggle} to={"/plumbing"}>
                    {" "}
                    <li>Plumbing</li>
                  </Link>
                  <Link onClick={showToggle} to="/haulage">
                    <li>Haulage and Removals</li>
                  </Link>
                </div>
              </div>
              <Link onClick={showToggle} to="/project">
                <li className="nav-link pb-4">Projects</li>
              </Link>
              <Link onClick={showToggle} to="/login">
                <li className="nav-link">Login</li>
              </Link>
              <Link onClick={showToggle} to="/admin">
              <li className="nav-link">Admin-Login</li>
              </Link>
            </ul>
          </div>
        </div>
      ) : (
        <div className="duration-[350ms]  ease-in-out right-[-100%]"></div>
      )}
    </>
  );
};

export default Header;
